import { ServiceType } from "@/constants/enum";
import { Merchant } from "@/dto/merchant";
import { Service } from "@/dto/service";
import { FEATURE_FLAG_SHIPPING } from "@/utils/constants";
import { hasMerchantFeatureFlag } from "@/utils/merchantFeatureFlags";
import { isShippingAvailable } from "@/utils/shippingUtils";

const isDineInBusinessOpen = (
  merchant: Merchant,
  activeDaypartMenu: boolean
): boolean => {
  if (!activeDaypartMenu) return false;

  const dineInService = merchant.services.find(
    (service: Service) => service.type === ServiceType.DINE_IN
  );
  const isDineInClosed =
    merchant.serviceHoursInformation?.DINE_IN?.serviceHoursState === "CLOSED";

  return Boolean(dineInService && !isDineInClosed);
};

const hasEnabledPickupOrWebsite = (merchant: Merchant): boolean => {
  const service = merchant.services.find(
    (candidate: Service) =>
      candidate.type === ServiceType.PICKUP ||
      candidate.type === ServiceType.WEBSITE
  );

  return service?.enabled === true;
};

const hasAlternativeRetailFulfillment = (merchant: Merchant): boolean => {
  if (!merchant.isRestaurant && !merchant.isRetail) return false;

  const curbsideService = merchant.services.find(
    (service: Service) => service.type === ServiceType.CURBSIDE
  );

  return curbsideService?.enabled === true || merchant.isDeliveryEnabled;
};

export const isBusinessOpen = (
  merchant: Merchant,
  isDineIn: boolean = false,
  activeDaypartMenu: boolean = true
): boolean => {
  if (isDineIn) return isDineInBusinessOpen(merchant, activeDaypartMenu);

  const shippingAvailable = isShippingAvailable(
    merchant,
    hasMerchantFeatureFlag(merchant, FEATURE_FLAG_SHIPPING)
  );
  if (shippingAvailable) return true;

  return (
    hasEnabledPickupOrWebsite(merchant) ||
    hasAlternativeRetailFulfillment(merchant)
  );
};
